import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { IqTrackingSegmentService } from './iq-tracking-segment.service';
import { IqTrackingOtelService } from './iq-tracking-otel.service';

type IqTrackingState = {
    segmentInitialized: boolean;
    otelInitialized: boolean;
};

@Injectable({
    providedIn: 'root',
})
export class IqTrackingStateService extends ComponentStore<IqTrackingState> {
    private _segment: IqTrackingSegmentService = inject(
        IqTrackingSegmentService,
    );
    private _otel: IqTrackingOtelService = inject(IqTrackingOtelService);

    readonly initialized: WritableSignal<boolean> = signal(false);

    constructor() {
        super({ segmentInitialized: false, otelInitialized: false });
    }

    jsError(message: string, error: Error) {
        this._otel.jsError({ message, error, info: null });
    }

    initialize(): void {
        if (this.initialized()) return;
        
        this._segment.initialize();
        this._otel.initialize();

        this.initialized.set(true);
        this.patchState({ segmentInitialized: true, otelInitialized: true });
    }
}
